<ng-container *ngIf="visible">
    <app-dialog [title]="dialogTitle" [disabled]="true" [template]="detailRecinto" (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #detailRecinto>
        <!-- Para mostrar los datos básicos del recinto -->
        <app-recinto-wrapper-edit [id]="Id" [editMode]="editMode" [dialogMode]="true"></app-recinto-wrapper-edit>
        <!-- Para mostrar la lista de cultivos del recinto -->
        <app-cultivo-wrapper [dialogMode]="true" [id]="Id"></app-cultivo-wrapper>
    </ng-template>
</ng-container>
